import Layouts from "./layouts/index.js";
const { CustomerStories } = Layouts;
export default {
    CustomerStoriesComponent: {
        type: "CustomerStoriesComponent",
        title: "Customer Stories Carousel",
        imgSrc: "/static/img/segments/layouts/multi-products-pricing.png",
        config: CustomerStories.CustomerStoriesConfig,
        advancedConfig: CustomerStories.CustomerStoriesAdvancedConfig,
        component: CustomerStories.CustomerStoriesComponent
    }
};
